import apiService from 'services/apiService';
import { getQueryString } from 'modules/MonitorAlpha/shared/utils';

const baseUrl = `${window._env_.MONITOR_API_DOMAIN}`;

const getInsights = (entityId, queryParams) => {
  const queryString = getQueryString(queryParams);
  const url = `${baseUrl}/v1/entities/${entityId}/introducer/clients/insights/count${queryString}`;
  return apiService.get(url);
};

export { getInsights };
